import clsx from 'clsx';
import React from 'react';
import { createUseStyles } from 'react-jss';

import { media } from '../utils/constants';

const useStyles = createUseStyles({
  layout: {
    composes: 'flexRow justifyCenter center noWrap stretchSelf',
  },
  layoutContent: {
    composes: 'flexRow',
  },
  layoutWithWidth: {
    [media.xxlUp]: {
      width: 1200,
    },
    [media.xxlDown]: {
      width: '60vw',
    },
    [media.mdDown]: {
      width: '60vw',
    },
    [media.smDown]: {
      width: '96%',
    },
  },
  layoutFullWidth: {
    width: '100%',
  },
});

const Layout = ({ children, rootClassName, className, fullWidth = false, id }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.layout, rootClassName)} id={id}>
      <div className={
          clsx(
            fullWidth ? classes.layoutFullWidth : classes.layoutWithWidth, 
            classes.layoutContent, 
            className,
          )
        }
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;
